import { render, staticRenderFns } from "./PopperDropdown.vue?vue&type=template&id=0ae2b346&"
import script from "./PopperDropdown.vue?vue&type=script&lang=js&"
export * from "./PopperDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports